import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { XCircleIcon } from '@heroicons/react/solid'
import tools from '../../tools'

class YourStay extends Component {
	constructor(props) {
		super(props)
		this.state = {
			form1: {
				stay: ''
			},
			redirect: false,
			error: null,
			success: null
		}
	}

	componentDidMount() {
		this.props.updateLogs(this.props.history.location.pathname, 'Membres')
		this.props.updateShell('profile', true, this.props.history.location.pathname)
	}

	setErrorMsg = (msg) => {
		this.setState({ success: null, error: msg })
	}

	handleStay = (stay) => {
		this.setState({ form1: { stay: stay } })
	}

	handleSubmit = (event) => {
		event.preventDefault()
		if (this.state.form1.stay === '')
		{
			this.setState({ error: "Veuillez sélectionner un séjour" })
		}
		else
		{
			const updatedUser = {
				...this.props.user,
				stay_list: this.props.user.stay,
				stay: this.state.form1.stay
			}
			this.props.updateUser(updatedUser, this.props.session)
			this.setState({ redirect: true })
		}
	}

	render() {
		if (this.state.redirect === true)
		{
			return (
				<Redirect to="/membres" />
			)
		}

		let stays = (this.props.user.stay_list) ? this.props.user.stay_list : this.props.user.stay
		if (!Array.isArray(stays))
			stays = [stays]
		stays = stays.filter(s => s && s.stay_number && s.stay_number !== '?')

		const themeColor = '#' + this.props.theme.color1
		const btnStyle = "font-semibold py-5 w-full rounded-full text-white shadow-xl text-xl my-10 waves-effect waves-light"

		let error = null
		if (this.state.error)
		{
			error = (
				<div className="rounded-md bg-red-50 p-4 mt-3">
					<div className="flex">
						<div className="flex-shrink-0">
							<XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
						</div>
						<div className="ml-3">
							<h3 className="text-sm font-medium text-red-800">{this.state.error}</h3>
						</div>
					</div>
				</div>
			)
		}

		if (stays.length === 0)
		{
			return (
				<div>
					<div style={{ backgroundColor: themeColor }} className="h-52 z-0 px-8 text-center">
						<h1 className="text-3xl text-white font-semibold m-0 pt-16">Vos séjours</h1>
					</div>
					<div className="rounded-t-3xl z-10" style={{ backgroundColor: "#ffffff", marginTop: "-2rem" }}>
						<div className="flex flex-col items-center justify-center px-10 pt-20 pb-10 text-center">
							<span className="text-5xl mb-6" role="img" aria-label="calendar">📅</span>
							<p className="text-xl font-semibold text-gray-700 mb-3">Aucun séjour à venir</p>
							<p className="text-sm text-gray-400">Votre prochaine réservation apparaîtra ici dès qu'elle sera disponible dans notre système.</p>
						</div>
					</div>
				</div>
			)
		}

		const time_now = tools.getTimestamp()
		return (
			<div>
				<div style={{ backgroundColor: themeColor }} className="h-52 z-0 px-8 text-center">
					<h1 className="text-3xl text-white font-semibold m-0 pt-16">Vos séjours</h1>
				</div>
				<div className="rounded-t-3xl z-10" style={{ backgroundColor: "#ffffff", marginTop: "-2rem" }}>
					<div className="px-10 pt-16 pb-10">
						<h2 className="text-3xl font-semibold text-gray-700 mb-10">Choisissez votre séjour dans la liste</h2>
						<form onSubmit={this.handleSubmit}>
							<div className="space-y-5">
								{stays.map(stay => {
									let stay_location = ''
									if (stay.arrival_time < time_now || this.props.show_stay_location === true)
										stay_location = stay.location
									return (
										<div key={stay._id} className="relative flex items-center">
											<div className="flex items-center h-5">
												<input
													id={stay._id}
													name="stay"
													type="radio"
													onChange={this.handleStay.bind(this, stay)}
													className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
												/>
											</div>
											<div className="ml-3 text-lg">
												<label htmlFor={stay._id}>
													<p className="font-semibold text-gray-700">
														{stay.location_category} {stay_location}
													</p>
													<p className="text-gray-500">
														{stay.arrival} - {stay.departure}
													</p>
												</label>
											</div>
										</div>
									)
								})}
							</div>
							{error}
							<button type="submit" className={btnStyle} style={{ backgroundColor: themeColor }}>Enregistrer</button>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default YourStay
